//SHMANTIKO! gia na doylepsei ayto prepei na bgaloyme to useEffect apo to tabsTimelineSub
// (const isNavigatingBetweenTabs ...) alliws kanei axreiasto reset to state kai xalaei to navigation!!!
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Button, Tooltip } from 'components';
import SubmitModal from '../../components/layout/components/submitModal';
import { isAuditor } from 'utils';
import { isNil, omit, isEmpty } from 'lodash';
import { getLocalString, localNames } from 'utils/localisation.service';
import { handleSubmit } from 'utils';
import { submitTask, updateFormField } from 'store/forms/actions';
import { ReturnModal } from './components';

const FormFooter = ({
  actions,
  current,
  setCurrent,
  currentSubTab,
  steps,
  tabs,
}) => {
  const locales = useSelector(state => state.forms?.localeStrings);
  const task = useSelector(state => state.forms.task);
  const state = useSelector(state => state.forms);
  const user = useSelector(state => state.user);
  const documents = useSelector(state => state.forms.documents);
  const businessKey = useSelector(state => state.forms.businessKey);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [outcome, setOutcome] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState('');
  const params = useParams();
  const location = useLocation();

  const finalTabs = tabs.map(item => {
    if (item.tabsComponent) {
      return {
        ...item,
        tabsComponent: item.tabsComponent.filter(tab => tab.disabled === false),
      };
    }
    return item;
  });

  useEffect(() => {
    if (isVisible && isAuditor(user?.groups)) {
      setOutcome('return');
    }
  }, [isVisible]);

  // debug log
  // useEffect(() => {
  //   console.log('currentSubTab changed to:', currentSubTab);
  //   console.log('current tab is:', current);
  // }, [currentSubTab]);

  useEffect(() => {
    // console.log('current tab changed to:', current);
    // console.log('with finalTabs structure:', finalTabs);
    if (current === 0 && !currentSubTab) {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'currentSubTab',
          value: 0,
        })
      );
    }
  }, [current]);

  const setPrev = current => {
    // console.log('setPrev called with current:', current);
    // console.log('currentSubTab before setPrev:', currentSubTab);
  
    // info apo to tab poy erxomaste!
    const comingFromTab = finalTabs[current + 1];
    console.log('Coming from tab:', comingFromTab);

    // check gia to an to Tab poy erxomaste exei subtabs ( akoma kai an einai disabled )
    const hasSubtabs = comingFromTab?.tabsComponent?.length > 0;
    // metrame posa subtabs einai enabled
    const enabledSubtabsCount = comingFromTab?.tabsComponent?.filter(
      tab => !tab.disabled
    ).length;
    
    // console.log('Has subtabs:', hasSubtabs);
    // console.log('Number of enabled subtabs:', enabledSubtabsCount);
  
    setCurrent(current);
  
    if (finalTabs[current]?.subtabs) {
      const targetTabEnabledSubtabs = finalTabs[current].tabsComponent.filter(
        tab => !tab.disabled
      );

      // console.log("targetTabEnabledSubtabs",enabledSubtabsCount);

      // An erxomaste apo tab poy exei subtabs alla mono 1 einai enebled ( san to Tab2 )
      // na mas paei sto teleytaio subtab toy prohgoymenoy tab!!
      const shouldGoToLastSubtab = hasSubtabs && enabledSubtabsCount === 1;
      const targetSubTab = shouldGoToLastSubtab 
        ? targetTabEnabledSubtabs.length - 1 
        : currentSubTab;
  
      // console.log('Should go to last subtab:', shouldGoToLastSubtab);
      // console.log('Target subtab:', targetSubTab);
  
      // dispatch(
      //   updateFormField({
      //     group: 'carrier',
      //     key: 'currentSubTab',
      //     value: targetSubTab,
      //   })
      // );
    } else {
      console.log('Target tab has no subtabs, setting subtab to 0');
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'currentSubTab',
          value: 0,
        })
      );
    }
  };

  const setNext = current => {
    console.log('setNext called with current:', current);
    console.log('currentSubTab value when moving next:', currentSubTab);
    
    Promise.resolve().then(() => {
      setCurrent(current + 1);
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'currentSubTab',
          value: 0, // Panta ksekiname apo to prvto subtab toy epomenoy tab 
        })
      );
    });
  };

  const commonActions = [
    // previous button
    current !== 0 && {
      label: getLocalString(locales, localNames.REQUEST_PAGE_PREVIOUSBUTTON),
      type: 'default',
      className: 'dark-grey',
      onClick: () => {
        // console.log('Previous button clicked in commonActions');
        // console.log('Current tab:', current);
        // console.log('Current subtab:', currentSubTab);
        // console.log("finalTabs[current]?.subtabs:",finalTabs[current-1].tabsComponent.length);
        setPrev(current - 1);
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'currentSubTab',
            value: finalTabs[current-1].tabsComponent.length-1,
          })
        );
      },
    },
    // next button
    current < finalTabs.length - 1 && {
      label: getLocalString(locales, localNames.REQUEST_PAGE_NEXTBUTTON),
      type: 'primary',
      id: 'next-step-btn',
      className: 'brown-grey',
      onClick: () => {
        // console.log('Next button clicked in commonActions');
        // console.log('Current tab before next:', current);
        // console.log('Current subtab before next:', currentSubTab);
  
        const enabledTabs = finalTabs[current]?.tabsComponent?.filter(
          tab => !tab.disabled
        );
        const lastEnabledTabIndex = enabledTabs?.length - 1;
  
        if (!isNaN(lastEnabledTabIndex) && currentSubTab !== lastEnabledTabIndex) {
          dispatch(
            updateFormField({
              group: 'carrier',
              key: 'currentSubTab',
              value: currentSubTab + 1,
            })
          );
        } else {
          setNext(current);
        }
      },
    },
  ].filter(Boolean);

  const commonActionsSub = [
    // previous button
    (currentSubTab !== 0 || current !== 0) && {
      label: getLocalString(locales, localNames.REQUEST_PAGE_PREVIOUSBUTTON),
      type: 'default',
      id: 'prev-step-button',
      className: 'dark-grey',
      onClick: () => {
        // console.log('Previous button clicked in commonActionsSub');
        // console.log('Current tab:', current);
        // console.log('Current subtab:', currentSubTab);
        
        if (currentSubTab !== 0) {
          dispatch(
            updateFormField({
              group: 'carrier',
              key: 'currentSubTab',
              value: currentSubTab - 1,
            })
          );
        } else {
          // console.log("finalTabs[current]?.subtabs:ENTEREDDDDDDD",finalTabs[current-1].tabsComponent.length);
          dispatch(
            updateFormField({
              group: 'carrier',
              key: 'currentSubTab',
              value: finalTabs[current-1].tabsComponent.length-1,
            })
          );
          setPrev(current - 1);
        }
      },
    },
    // next button
    current < finalTabs.length - 1 && {
      label: getLocalString(locales, localNames.REQUEST_PAGE_NEXTBUTTON),
      type: 'primary',
      id: 'next-step-btn',
      className: 'brown-grey',
      onClick: () => {
        // console.log('Next button clicked in commonActionsSub');
        // console.log('Current tab before next:', current);
        // console.log('Current subtab before next:', currentSubTab);

        const enabledTabs = finalTabs[current]?.tabsComponent?.filter(
          tab => !tab.disabled
        );
        const lastEnabledTabIndex = enabledTabs?.length - 1;

        if (currentSubTab !== lastEnabledTabIndex) {
          dispatch(
            updateFormField({
              group: 'carrier',
              key: 'currentSubTab',
              value: currentSubTab + 1,
            })
          );
        } else {
          setNext(current);
        }
      },
    },
  ].filter(Boolean);

  const specialActions = [
    {
      label: 'Επιστροφή στον Δικαιούχο',
      id: 'return-to-investor',
      type: 'default',
      className: 'dark-grey',
      visible: tooltipVisible === 'return-to-investor',
      onVisibleChange: v => setTooltipVisible(v ? 'return-to-investor' : ''),
      onClick: () => {
        setIsVisible(true);
      },
      disabled: isEmpty(documents?.audDocsCompletenessReport),
    },
  ].filter(item => item);

  return (
    <div className="form-footer">
      <SubmitModal
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        businessKey={businessKey}
        formKey={task.formKey}
        outcome={outcome}
        handleSubmit={() =>
          handleSubmit({
            state: { ...state },
            user: { ...user },
            dispatch,
            submitTask,
            navigate,
            setIsVisible,
            taskId: params.taskId,
            formKey: task.formKey,
            outcome,
          })
        }
      />

      <div className="form-footer__divider"></div>

      <div className="form-footer__actions-wrapper">
        {isAuditor(user?.groups) && currentSubTab === 1 && (
          <div className="form-footer__actions form-footer__actions--left">
            {false && !isEmpty(specialActions) &&
              specialActions?.map((action, index) => (
                <Button key={'special-btn-' + index} {...action} />
              ))}
          </div>
        )}
        <div className="form-footer__actions right-placement">
          {finalTabs[current]?.subtabs
            ? commonActionsSub?.map((action, index) => (
                <Button key={index} {...action} />
              ))
            : commonActions?.map((action, index) => (
                <Button key={'common-btn-' + index} {...action} />
              ))}
        </div>
      </div>
    </div>
  );
};

export default FormFooter;